<template>
<div  v-if="formid!=0">   
    <button  @click.prevent="openwindow()"  class="btn btn-default">
    <i class="glyphicon glyphicon-cog"></i> {{ translation(649) }}
    </button>    
</div>
</template>
<script>

 import { mapActions } from 'vuex'
export default {
  props: {
      type: {
        type: Number
      },
      formid: {
        type: Number
      },
      validations: {
        type: Boolean,
        default: false
      }
  },
  mounted: function (){
    this.gettranslations([649])
  },
  methods: {     
    ...mapActions(['gettranslations']),    
    openwindow: function(){
      window.open('/peapp/eval/formid/' + this.formid + '/' + this.type + '/' + this.validations, 'evalPreviewTab')
    }
    
  }
}
</script>
